import { handleError, handleSuccess, handleSuccessWithStatus, wait } from '../helpers';

import type { ResponseResolverProps } from './resolvers.d';

export async function resolve206({ params, response, url }: ResponseResolverProps) {
  const { pathname } = new URL(url);
  const requestPath = pathname.substring(pathname.lastIndexOf('/'));
  const pathsWithLimitedAttempts = ['/paymentplans'];
  const pathToIgnore = ['/item'];
  let fullResponse: Response = response;

  if (pathToIgnore.includes(requestPath)) {
    return handleSuccessWithStatus(fullResponse);
  } else if (pathsWithLimitedAttempts.includes(requestPath)) {
    let attempts = 0;

    do {
      // eslint-disable-next-line no-await-in-loop
      const partialResponse = await fetch(url, params);

      if (!partialResponse.ok && partialResponse.status > 299) {
        return handleError(partialResponse);
      }

      if (partialResponse.status === 200) {
        return handleSuccess(partialResponse);
      }

      attempts += 1;

      fullResponse = partialResponse;

      // eslint-disable-next-line no-await-in-loop
      await wait(2000);
    } while (fullResponse.status === 206 && attempts < 6);

    if (fullResponse.status === 206) {
      return handleError(fullResponse);
    }
  }

  return handleError(fullResponse);
}
